export function Trans({ children }: any) {
  return <>{children}</>
}
